import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    pageTitle: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.pageTitle",
    buttonApprove: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.buttonApprove",
    buttonReject: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.buttonReject",
    buttonForward: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.buttonForward",
    buttonPreview: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.buttonPreview",
    buttonRefreshToolTip: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.buttonRefreshToolTip",
    columnMatterId: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnMatterId",
    columnRecipientName: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnRecipientName",
    columnContactName: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnContactName",
    columnInvoiceRegarding: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnInvoiceRegarding",
    columnFeeStatement: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnFeeStatement",
    columnFee: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnFee",
    columnBillableAmount: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnBillableAmount",
    columnnTotalMatterLedgerEntries: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnnTotalMatterLedgerEntries",
    columnApproverFlow: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnApproverFlow",
    columnCurrentApproverFlowComment: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnCurrentApproverFlowComment",
    columnLiableLawyer: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnLiableLawyer",
    columnClientLeadLawyer: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnClientLeadLawyer",
    columnMatterType: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnMatterType",
    columnLawyer: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnLawyer",
    columnAttorney: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.columnAttorney",
    functionHelpText: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.functionHelpText",
    dynamicInvoicePageHelp: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.dynamicInvoicePageHelp",
    deleteButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.deleteButton",
    deleteConfirmationMessageSingular: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.deleteConfirmationMessageSingular",
    deleteConfirmationMessagePlural: "domains.dynamic-invoice.pages.dynamic-invoice-page.dynamic-invoice-page-i18n.deleteConfirmationMessagePlural"
};
export const translations = {
    da: {
        pageTitle: "Godkend fakturaforslag",
        buttonApprove: "Godkend faktura",
        buttonReject: "Afvis faktura",
        buttonForward: "Videregiv faktura",
        buttonPreview: "Preview",
        buttonRefreshToolTip: "Opdater",
        columnMatterId: "Sagsnr.",
        columnRecipientName: "Fakturamodtager",
        columnContactName: "Faktura til kontaktperson",
        columnInvoiceRegarding: "Faktura vedrørende",
        columnFeeStatement: "Fakturatekst",
        columnFee: "Salær",
        columnBillableAmount: "Debiterbart beløb",
        columnnTotalMatterLedgerEntries: "Finansposter",
        columnApproverFlow: "Godkendelsesflow",
        columnCurrentApproverFlowComment: "Aktuel kommentar",
        columnLiableLawyer: "Sag ansvarlig jurist",
        columnClientLeadLawyer: "Klient ansvarlig jurist",
        columnLawyer: "Jurist",
        columnAttorney: "Fuldmægtig",
        columnMatterType: "Sagstype",
        functionHelpText: "Hjælp til funktioner",
        dynamicInvoicePageHelp: "Web godkendelse",
        deleteButton: "Slet",
        deleteConfirmationMessageSingular: "Du har valgt en faktura til sletning. Ønsker du at fortsætte?",
        deleteConfirmationMessagePlural: "Du har valgt {{ count }} fakturaer til sletning. Ønsker du at fortsætte?"
    },
    en: {
        pageTitle: "Approve invoice draft",
        buttonApprove: "Approve invoice",
        buttonReject: "Reject invoice",
        buttonForward: "Forward invoice",
        buttonPreview: "Preview",
        buttonRefreshToolTip: "Refresh",
        columnMatterId: "Matter no.",
        columnRecipientName: "Invoice recipient",
        columnContactName: "Invoice for contact",
        columnInvoiceRegarding: "Invoice regarding",
        columnFeeStatement: "Invoice text",
        columnFee: "Fee",
        columnBillableAmount: "Billable amount",
        columnnTotalMatterLedgerEntries: "General ledger entries",
        columnApproverFlow: "Approval flow",
        columnCurrentApproverFlowComment: "Current comment",
        columnLiableLawyer: "Matter liable lawyer",
        columnClientLeadLawyer: "Client liable lawyer",
        columnAttorney: "Attorney",
        columnLawyer: "Lawyer",
        columnMatterType: "Matter type",
        functionHelpText: "Help functions",
        dynamicInvoicePageHelp: "Invoice approval",
        deleteButton: "Delete",
        deleteConfirmationMessageSingular: "You have chosen to delete one invoice. Do you wish to continue?",
        deleteConfirmationMessagePlural: "You have chosen to delete {{ count }} invoices. Do you wish to continue?"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        pageTitle: t(k.pageTitle),
        buttonApprove: t(k.buttonApprove),
        buttonReject: t(k.buttonReject),
        buttonForward: t(k.buttonForward),
        buttonPreview: t(k.buttonPreview),
        buttonRefreshToolTip: t(k.buttonRefreshToolTip),
        columnMatterId: t(k.columnMatterId),
        columnRecipientName: t(k.columnRecipientName),
        columnContactName: t(k.columnContactName),
        columnInvoiceRegarding: t(k.columnInvoiceRegarding),
        columnFeeStatement: t(k.columnFeeStatement),
        columnFee: t(k.columnFee),
        columnBillableAmount: t(k.columnBillableAmount),
        columnnTotalMatterLedgerEntries: t(k.columnnTotalMatterLedgerEntries),
        columnApproverFlow: t(k.columnApproverFlow),
        columnCurrentApproverFlowComment: t(k.columnCurrentApproverFlowComment),
        columnLiableLawyer: t(k.columnLiableLawyer),
        columnClientLeadLawyer: t(k.columnClientLeadLawyer),
        columnLawyer: t(k.columnLawyer),
        columnAttorney: t(k.columnAttorney),
        columnMatterType: t(k.columnMatterType),
        functionHelpText: t(k.functionHelpText),
        dynamicInvoicePageHelp: t(k.dynamicInvoicePageHelp),
        deleteButton: t(k.deleteButton),
        deleteConfirmationMessage: (count) => t(count === 1 ? k.deleteConfirmationMessageSingular : k.deleteConfirmationMessagePlural, { count })
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
